import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  homescreen: {
    marginTop: 20,
  },
  nav: {
    position: Platform.OS === 'web' ? 'fixed' : null,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 99999,
    // shadowColor: '#000000a1',
    // shadowOpacity: 1,
    // shadowRadius: 7,
  },
  rootStyle: {
    //maxWidth: 1300,   //changes made here , might have to revert it later 
    paddingTop: 0,
    paddingBottom: 0,
    // margin: 'auto',
    width: '100%',
    marginTop: 0,
    marginBottom: 0,
    //marginTop: 73,   //changes made here 
  },
  container: {
    marginTop: 0,
    minHeight: Platform.OS === 'web' ? '100vh' : '100%',
  },
  messageContainer:{
    flex: 1,
    alignItems: "center",
    paddingTop: "10%",
    backgroundColor: "#fcebd6"
  },
  messageHeading:{
    fontSize: 32, 
    fontWeight: "bold", 
    textAlign: "center", 
    fontFamily: "Mulish",
  },
  messageSubheading:{
    fontSize: 22, 
    textAlign: "center",
    fontFamily: "Mulish",

  }
});
